<template>
	<div class="father-product-detail">
		<transition name="cart-anim"  enter-active-class="animate__animated animate__backInUp" leave-active-class="animate__animated animate__backOutDown">
		<cart 
		v-if="content_cart" 
		:cart="ProductList"
		@productDeleted= "producto_borrado = $event"
		@closeCartDetail= "content_cart = $event">		
		</cart>
		</transition>
		<div class="content-product" v-show="!content_cart">
			<div class="nav-bar">
				<div class="back">
					<i class="fas fa-long-arrow-alt-left" @click="close()"></i>
				</div>
				<div class="cart">
					<!--<div class="container-cart">
						<i class="fas fa-shopping-cart"></i>
						<span class="count">1</span>
					</div>-->
				</div>
			</div>
			<div class="image-main" v-show="product_gallery.length == 0">
				<div class="big-image" id="ex1">
					<picture>
		                <img @click="setBannerPresentation('img1')" v-bind:src="url_images+product.galery_images[0]" alt="pjpg" rel="preconnect">
		            </picture>
				</div>
			</div>
			<div class="product-gallery" v-show="product_gallery.length == 3">
				<div class="first-image">
					<picture>
		                <img @click="setBannerPresentation('imagen1')" :src="url_images+product.galery_images[0]" alt="pjpg" rel="preconnect" id="imagen1">
		            </picture>
				</div>	

				<div class="image-gallery">
					<div class="gallery-item">
						<img @click="setBannerPresentation('imagen2')" :src="url_images+product_gallery[0]" alt="" id="imagen2">
					</div>
					<div class="gallery-item">
						<img @click="setBannerPresentation('imagen3')" :src="url_images+product_gallery[1]" alt="" id="imagen3">
					</div>
					<div class="gallery-item">
						<img @click="setBannerPresentation('imagen4')" :src="url_images+product_gallery[2]" alt="" id="imagen4">
					</div>
				</div>
			</div>
			<div class="product-description">
				<div class="product-name">
					<h4> {{ product.name }}</h4>
				</div>
				<div class="price-quantity">
					<div class="product-price">
						<h4>${{ Intl.NumberFormat("de-DE").format(form.price * form.quantity) }}</h4>
					</div>
					<div class="product-quantity">
						<div class="less" @click="removeQuantity()">
							<i class="fas fa-minus"></i>
						</div>
						<div class="quantity-value">
							<label>{{form.quantity}}</label>
						</div>
						<div class="more"  @click="addQuantity()">
							<i class="fas fa-plus"></i>
						</div>
					</div>
				</div>
				<div class="total-units" v-show="form.statusCombination || total_units > 0" v-bind:style="{ color: color_licencia }">
					<h4>Unidades disponibles: {{ total_units }}</h4>
				</div>
				<div class="custom-quantity">
					<h4 v-bind:style="{ color: color_licencia }" @click="custom_state = true" v-show="custom_quantity">Usar cantidad personalizada<i class="fas fa-sort-down"></i></h4>
					<input type="text" v-model="quantity_custom" v-show="custom_state && custom_quantity" placeholder="Ingrese la cantidad">
					<span v-if="out_stock">Se excedió la cantidad en inventario</span>
					<span v-if="warning">La cantidad debe ser mayor o igual a 1</span>
				</div>				
				<div class="variantes">					
					<div class="variante1" v-for="(variant,i) in product.variantes" :key="i">
						<select name="select" :id="variant.name_variant+'_'+variant.id_product" @change="getPriceProductCombination()">
						 	<option value="0" disabled selected>Seleccione</option>
							<option :value="variant.name_variant+'_'+detail.option" v-for="(detail,i) in product.variantes_detail" :key="i" v-if="detail.id_product_variant == variant.id_product_variant">{{ detail.option }}</option>
						</select>
					</div>
				</div>
				<div v-if="product.status_variants && !form.statusCombination" style="text-align: left;margin-left: 5px;">
					<label class="alerts" v-if="product.variantes.length > 1" v-bind:style="{ color: color_licencia }">Seleccione las {{ product.variantes.length }} opciones.</label>
					<label class="alerts" v-else v-bind:style="{ color: color_licencia }">Seleccione la opción.</label>
				</div>
				<div class="description">
					<h4 class="title-description">Descripción</h4>
					<p id="product_parrafo">{{ product.description }}</p>
				</div>
				<div class="boton-comprar">
					<button id="addtocart" @click="addProductCart()" v-bind:style="{ backgroundColor: color_licencia }">
	    			Añadir al carrito
	    			<span class="cart-item"></span>
	 				</button>
	 				<button id="whishlist">
	    			<i class="far fa-heart"></i>
	 				</button>
				</div>
			</div>

			<!--<div class="loader-wrapper">
	      		<span class="loader"><span class="loader-inner"></span></span>
	   		</div>-->

			<!--<div class="add-to-cart">
				<h4 class="add-to-cart-button"><i class="fas fa-shopping-cart"></i>Añadir al carrito</h4>
			</div>-->
			<div id="cart-2" class="cart-1" data-totalitems="1">
	  		<i class="fas fa-shopping-cart" @click="openCart(ProductList)"></i>
			</div>
		</div>
		<div class="order-out" v-if="sale_out">
			<div class="canceled-info">
				<i class="fas fa-exclamation-triangle"></i>
				<h4>Este producto está agotado</h4>
				<button @click="close()">Volver</button>
			</div>
		</div>
	</div>
</template>

<!--<style scoped>
  @import './css/ecommerce.css';
</style>-->

<style lang="scss" scoped>

	*:focus{
		outline:none !important;	
	}


	.order-out{
			width: 100%;
			height: 127vh;
			position: absolute;
			top: 0;
			background-color: rgba(0, 0, 0, .6);
			display: flex;
			justify-content: center;
			align-items: center;
		}

	@media only screen and (min-width: 1280px) and (max-width: 1920px){
		.order-out{
			width:50%;
			height: 200vh;
			margin: 0 auto;
		}
	}	

		.canceled-info{
			background: #fff;
			width: 80%;
			margin: 0 auto;
			padding-top: 20px;
			text-align: center;
			display: block;
			border-radius: 10px;
		}

		.canceled-info i{
			color: #E43A3A;
			font-size: 29px;
		}

		.canceled-info h4{
			font-family: 'Poppins', sans-serif;
			font-size: 17px;
			font-weight: 500;
			padding-top: 14px;
		}

		.canceled-info button{
			width: 100%;
			border-bottom: none;
			border-left: none;
			border-right: none;
			box-shadow: none !important;
			background: transparent;
			border-top: 1px solid #E8E8E8;
			margin-top: 10px;
			padding-top: 15px;
			padding-bottom: 15px;
			font-family: 'Poppins', sans-serif;
			font-size: 16px;
			color: #000;
		}


	.custom-quantity{
		width:100%;
		text-align: left;
		/*display:flex;
		justify-content:flex-start;
		align-items:center;*/
	}

	.custom-quantity h4{
		font-size: 15px;
		font-weight: 500;
		cursor: pointer;
	}

	.custom-quantity i{
		margin-left: 4px;
	}

	.custom-quantity input{
		width: 100%;
		padding: 5px 10px;
		margin-top:5px;
		border: 1px solid #ddd;
	}

	.custom-quantity span{
		font-size: 15px;
		font-weight: 500;
		color:red;
	}

	.total-units{
		width: 100%;
		text-align: left;
	}
	.total-units h4{
		font-size: 15px;
		font-weight: 500;
	}


	.alerts{
		font-size: 13px !important;
		font-weight: 600;
	}
	.content-product{
		height: 100%;
		width: 100%;
	}

	.content-product .back{
		width: 50%;
		text-align: left;
		align-items: center;
		padding-left: 20px;
	}

	.back i{
		font-size: 20px;
	}

	.content-product .cart{
		width: 50%;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-right: 20px;
	}

	.nav-bar{
		padding-top: 17px;
		padding-bottom: 17px;
	}

	.image-main{
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.big-image{
		width: 100%;
		height:auto;
		margin: 0;
		border-bottom-right-radius: 20px;
		border-bottom-left-radius: 20px;
		overflow: hidden;
	}
	.big-image img{
		width: 100%;
		height: auto;
	}

	.product-gallery{
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.first-image{
		width: 75%;
		height: auto;
		margin:0;
		overflow: hidden; 
	}

	.first-image img{
		width: 100%;
		height: auto;
	}

	.image-gallery{
		width: 25%;
		margin: 0;
	}

	.gallery-item{
		background-color: #000;
	}

	.gallery-item img{
		width: 100%;
		height: auto;
		opacity: .7;
	}

	.add-to-cart{
		box-shadow: 0px 0px 15px 0px rgba(237,237,237,1);
		background-color: #015DFE;
		border-top-right-radius: 35px;
		border-top-left-radius: 35px;
		width: 100%;
		padding-top: 15px;
		padding-bottom: 15px;
		position: fixed;
		bottom: 0;
	}
	.add-to-cart i{
		color: #fff;
		font-size: 17px !important;
		padding-right: 10px;
	}

	.add-to-cart-button{
		color: #fff;
		font-size: 20px;
		font-weight: 500;
		letter-spacing: 1px;
		padding-left: 10px;
	}

	.product-description{
		width: 100%;
		padding-top: 25px;
		padding-left: 20px;
		padding-right: 20px;
	}

	.product-name{
		width: 100%;
		text-align: left;
	}
	.price-quantity{
		display: flex;
		justify-content: center;
	}

	.product-quantity{
		display: flex;
		width: 50%;
		justify-content: flex-end;
	}
	.product-price{
		width: 50%;
		text-align: left;
	}

	.product-price h4{
		margin-bottom: 0 !important;
		font-size: 22px;
	}

	label{
		margin-bottom: 0 !important;
	}

	.less{
		width: 20%;;
		background-color: #EAF0FD;
		padding-left: 10px;
		padding-right: 10px;
		border-radius: 10px;
		box-shadow: 0px 0px 9px 0px rgba(237,237,237,1);
	}

	.quantity-value{
		width: 10%;
		padding-left: 15px;
		padding-right: 25px;
		
	}

	.more{
		width: 20%;
		align-items: center;
		background-color: #EAF0FD;
		padding-left: 10px;
		padding-right: 10px;
		border-radius: 10px;
		box-shadow: 0px 0px 9px 0px rgba(237,237,237,1);
	}

	.more i{
		margin-top: 6px;
		color: #51565A;
	}

	.less i{
		margin-top: 6px;
		color: #51565A;
	}
	.quantity-value label{
		font-size: 20px;
	}

	.description{
		padding-top: 20px;
		padding-bottom: 20px;
		text-align: left;
	}
	.title-description{
		font-size: 18px;
		font-weight: 600;
	}

	.description p{
		text-align: justify;
		font-size: 15px;
	}

	.variantes{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		padding-top: 17px;
	}

	.variantes select{
		width: 95%;
		padding-top: 12px;
		padding-bottom: 12px;
		padding-left: 8px;
		padding-right: 15px;
		color: #51565A;
		background-color: #EAF0FD;
		cursor: pointer;
		border: none;
		border-radius: 5px;
		box-shadow: 0px 0px 9px 0px rgba(237,237,237,1);
		margin-bottom: 10px;
		appearance: none;
		-webkit-appearance: none;
		background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
		background-repeat: no-repeat;
		background-size: 28px;
		background-position-x: 100%;
	  	background-position-y: 12px;
	}
	.variantes select:focus{
		outline: none;
	}

	.variante1{
		width: 50%;
	}
	.variante2{
		width: 50%;
	}

	#addtocart:focus{
		outline: none;
		text-orientation: none;
	}

	.boton-comprar{
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding-bottom: 30px;
	}	

	#whishlist{
		width: 25%;
		background-color: #EAF0FD;
		color: #292d48;
		box-shadow: 0px 0px 9px 0px rgba(237,237,237,1);
		font-size: 27px;
	}

	button#whishlist:focus{
		outline:none;
	}

	button{
		width: 70%;
		padding:10px;
    	border:none;
    	background:#292d48;
    	position:relative;
   		outline:none;
    	border-radius:10px !important;
    	color:#fff;
    	font-size:22px;
    	font-weight: 500;
    	box-shadow: 0px 0px 9px 0px rgba(237,237,237,1);
    	.cart-item{
    		position:absolute;
      		height:24px;
      		width:24px;
      		top:-10px;
      		right:-10px;
      		&:before{
      			content:'1';
       			display:block;
        		line-height:24px;
        		height:24px;
        		width:24px;
        		font-size:12px;
        		font-weight:600;
       		 	background:#2bd156;
        		color:white;
        		border-radius:20px;
        		text-align:center;
      		}
    	}
    	&.sendtocart{
    		.cart-item{
    			display:block;
        		animation: xAxis 1s forwards cubic-bezier(1.000,0.440,0.840,0.165);
        		&:before{
        			animation: yAxis 1s alternate forwards cubic-bezier(0.165, 0.840, 0.440, 1.000);	
        		}	
    		}
    	}
	}
	.cart-1{
	position:fixed;
	top:10px;
	right:26px;
	width:40px;
	height:40px;
	background:#fff;
	display:flex;
	align-items:center;
	justify-content:center;
	border-radius:5px;
	transition: all .5s ease-in-out;
    i {
    font-size:20px;
    color:#292d48;	
  	}
  	&:before {
    content:attr(data-totalitems);
    font-size:12px;
    font-weight:600;
    position:absolute;
    top:-2px;
    right:-7px;
    background:#2bd156;
    line-height:21px;
    padding:0 5px;
    height:20px;
    min-width:20px;
    color:white;
    text-align:center;
    border-radius:24px;
  	}
  	&.shake {
    animation: shakeCart .4s ease-in-out forwards;
  		}
	}
	.cart-2 {
	  position:fixed;
	  top:10px;
	  right:26px;
	  width:40px;
	  height:40px;
	  background:#292d48;
	  display:flex;
	  align-items:center;
	  justify-content:center;
	  border-radius:5px;
	  transition: all .5s ease-in-out;
    i {
    font-size:20px;
    color:white;
  }
  &:before {
    content:attr(data-totalitems);
    font-size:12px;
    font-weight:600;
    position:absolute;
    top:-6px;
    right:-10px;
    background:#2bd156;
    line-height:21px;
    padding:0 5px;
    height:20px;
    min-width:20px;
    color:white;
    text-align:center;
    border-radius:24px;
  }
  &.shake {
    animation: shakeCart .4s ease-in-out forwards;
  }
	}

	@keyframes xAxis {
	  100% {
	    transform: translateX(calc(50vw - 105px));
	  }
	}

	@keyframes yAxis {
	  100% {
	    transform: translateY(calc(-96vh + 75px));
	  }
	}

	@keyframes shakeCart {
	  25% {
	    transform:translateX(6px)
	  }
	  50% {
	    transform:translateX(-4px);
	  }
	  75% {
	    transform:translateX(2px);
	  }
	  100% {
	    transform:translateX(0);
	  }
	}


</style>

<script>
	import Vue from 'vue'
	import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
	import $ from 'jquery'
	Vue.use(DatePickerPlugin);
	import 'vuesax/dist/vuesax.css' //Vuesax styles
	import Cart from './Cart';
	import axios from 'axios';
 
	export default {
	  props: ['product'],
	  components: {
	    Cart
	  },
	  data() {
	  	return {
	  		sale_out: false,
	  		warning: false,
	  		out_stock: false,
	  		custom_state: false,
	  		quantity_custom: 1,
	  		custom_quantity: JSON.parse(localStorage.getItem('custom_quantity')),
	  		url_images: localStorage.getItem('url_images'),
	  		ProductList: [],
	  		content_cart: false,
	  		contador: 0,
	  		product_gallery: this.product.gallery,
	  		total_units: 0,	  		
	  		no_inventory:true,
	  		textCombination: "",
	  		color_licencia: localStorage.getItem('color_licencia'),
	  		id_companie: localStorage.getItem('id_companie'),
	  		producto_borrado: {},	
	  		form:{
	  			statusCombination: false,
	  			combination: false,
	  			price: 0,
	  			priceaux: 0,
	  			quantity : 1,
	  		}

	  	}
	  },
	  watch:{
	  	content_cart: function(){
	  		$('#cart-2').addClass('shake').attr('data-totalitems', this.getListStorage().length);
	  	},
	  	producto_borrado: function(){
	  		if (this.producto_borrado != null) {
	  			this.product.stock.forEach((item) => {
	  				if (item.variante === this.producto_borrado.combination) {
	  					item.stock += this.producto_borrado.quantity;
	  				}
	  			})
	  		}
	  		this.updateCombination();
	  		this.getStockWithoutVariants();
	  	},
	  	quantity_custom: function(){
	  		if(this.custom_quantity){
	  			if (this.quantity_custom > this.total_units && !this.no_inventory) {
	  				this.out_stock = true;
	  				this.warning = false;
	  				$('#addtocart').prop('disabled', true);
	  			}else{
	  				$('#addtocart').prop('disabled', false);
	  				this.form.quantity = parseInt(this.quantity_custom); 
	  				if (isNaN(this.form.quantity)) {
		  				this.form.quantity = 1;
		  				this.warning = true;	
	  				}else{
	  					this.warning = false;
	  				}
	  				this.out_stock = false;
	  			}
	  		}else{
	  			this.form.quantity = parseInt(this.quantity_custom); 
	  			if (isNaN(this.form.quantity)) {
		  			this.form.quantity = 1;
		  			this.warning = true;	
	  			}else{
	  				this.warning = false;
	  			}
	  		}
	  	}
	  },
	  methods:{
	  	getPriceProductCombination(){
	  		  var self = this;
		      var combinaciones = this.product.variantes;
		      this.form.statusCombination = false;
		      this.form.combination = false;
		      this.textCombination = "";
		      //Verificamos si todos los valores de los select son <> de 0, si es asi el caso buscamos la combinación 
		      //y extraemos el valor.
		      combinaciones.forEach((combinacion,pos) => {

		          var value = document.getElementById(combinacion.name_variant+'_'+combinacion.id_product).value;  
		          if(value != 0){
		            if(pos == 0)self.textCombination += value.split('_')[1];
		            else self.textCombination += ' - '+value.split('_')[1];
		          }
		      });

		    if(this.textCombination.length > 0){
		        this.product.variantes_combinations.forEach((combination) => {            
		            if(combination.variant == self.textCombination){                  
		               self.form.price = parseFloat(combination.value);
		                if(self.form.price == 0){
		                   self.form.price = self.form.priceaux;
		                   var valueCombination = combination.value;
		                   valueCombination = parseFloat(combination.value);
		                   valueCombination = Math.trunc(valueCombination);
		                   self.form.price = parseFloat(self.form.price)+valueCombination;
		                }                                  
		                  
		                self.form.combination = combination.variant;
		                self.form.statusCombination = true;
		                this.updateCombination();
		                //this.restoreProductDeleted();
		            } 
		        }); 
		    }		      
	  	},
	  	updateCombination(){
	  		let product_stock = this.product.stock;
	  		this.form.quantity = 1;
		    product_stock.forEach((item) => {
		        if (item.variante === this.form.combination) {
		            this.total_units = item.stock;
		        }
		        if (this.total_units == 0 && !this.no_inventory) {
		            $('#addtocart').prop('disabled', true);
		        }else{
		            $('#addtocart').prop('disabled', false);
		        }	
		    })
	  	},
	  	close(){
  			this.$emit('closeProductDetail',false);
  		},
	  	addQuantity(){
	  	 if (!this.no_inventory){
	  	 	 if (this.product.status_variants) {
		  			if (this.form.quantity < this.total_units) this.form.quantity += 1;
		  		}else{
		  			if (this.form.quantity < this.total_units) this.form.quantity += 1;
		  		}
	  	 }else{
	  	 	 if (this.form.quantity >=0 ) this.form.quantity += 1;
	  	 }
	  	},
	  	removeQuantity(){
	  		if(this.form.quantity > 1) this.form.quantity -= 1;
	  	},
	  	setBannerPresentation(id){
 			let src_actual = document.getElementById(id).src;
 	 		let src_anterior = document.getElementById("imagen1").src;
  			document.getElementById("imagen1").src = src_actual;
  			document.getElementById(id).src = src_anterior;

		},
		saveApiConversion(uri,event,valor){
	     let data={
	      uri:uri,
	      event:event,
	      valor:valor
	     }
	     axios.post('https://back.vinapp.co/api/api-conversion',data)
	     .then(res=>{
	        console.log(res.data)
	     }).catch(err=>{

	     });
    }, 
		addProductCart(){
			if(this.product.status_variants && !this.form.statusCombination)return false;
			this.updateDesign();
			this.total_units -= this.form.quantity;			
			let product_cart = {
				'id' : this.product.id,
				'name' : this.product.name,
				'image' : localStorage.getItem('url_images') + this.product.galery_images[0],
				'description' : this.product.description,
				'value_sale' : this.form.price,
				'quantity' : this.form.quantity,
				'combination' : this.form.combination,
				'descuento': 0,
				'estado' : true
			}
			this.saveApiConversion(this.$route.params.id,'AddToCart',parseFloat(this.form.price)*this.form.quantity);			
			this.ProductList.push(product_cart);
			this.product.stock.forEach((item) => {
				if (item.variante === product_cart.combination) {
					item.stock -= product_cart.quantity;
					this.updateCombination();
				}
			})

			for(let i=0; i < localStorage.length;  i++){
				let llave = localStorage.key(i);
				if (llave.includes(`Cart_ ${localStorage.getItem('id_companie')}`)) {
					let lista = JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`));
					let search = lista.find(item => item.id == product_cart.id);
					let combination = lista.find(item => item.combination === product_cart.combination);

					if(search && combination){
						//EDIT
						let position = lista.indexOf(search)
						lista.splice(position, 1, product_cart)
					}else{
						lista.push(product_cart);
					}
					
					localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(lista));
					this.contador ++;
				}
			}
			this.getListStorage();
			if (this.contador == 0) {
				//localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(this.ProductList));
				localStorage.setItem(`Cart_ ${localStorage.getItem('id_companie')}`, JSON.stringify(this.ProductList));
			}
		},
		getListStorage(){
			for(let i=0; i < localStorage.length;  i++){
				let llave = localStorage.key(i);
				if (llave.includes(`Cart_ ${localStorage.getItem('id_companie')}`)) {
					return JSON.parse(localStorage.getItem(`Cart_ ${localStorage.getItem('id_companie')}`));
				}	
			}
			return []
		},
		validateExists(){
			let search = this.getListStorage().find(item => item.id == this.product.id)
			if(search) this.form.quantity = search.quantity
		},
		openCart(list){
			this.content_cart = list
		},
		updateDesign(){
			var self = this
		    var button = $('#addtocart');
		    var cart = $('#cart-2');
		    var cartTotal = cart.attr('data-totalitems');
		    let search = self.getListStorage().find(item => item.id == self.product.id);
		    let combination = self.getListStorage().find(item => item.combination === self.product.combination);
		    let newCartTotal = parseInt(cartTotal) + 1;
			if(search && combination) newCartTotal = parseInt(cartTotal);
		    button.addClass('sendtocart');
		    setTimeout(function(){
		      button.removeClass('sendtocart');
		      cart.addClass('shake').attr('data-totalitems', newCartTotal);
		      setTimeout(function(){
		        cart.removeClass('shake');
		      },500)
		    },1000)
		},
		getStockWithoutVariants(){
			var self = this;
			let stock = this.product.stock;
			if (stock.length == 1){
				if(stock[0].stock > 0){
					this.total_units = stock[0].stock;
				}				
			}else{
				self.total_units = 0;
				stock.forEach((item) => {
					if (item.stock > 0) {
						self.total_units += item.stock;
					}					
				});
			} 
		},
		getStockByProduct(id_product){
			axios
		  .get("https://admin.vinapp.co/api/get-stock-ecommerce/"+id_product)
		  .then( res => {
		    this.product.stock = res.data;

		    this.getStockWithoutVariants();
		    if (!this.no_inventory) {
		    	if (this.total_units == 0) this.sale_out = true;
		    }
		  }).catch( err => {
		    console.log(err);
		  });
			
		}
	  },
	  mounted() {
	  		this.getStockByProduct(this.product.id)
	  		//console.log(this.product);
	  		document.getElementById("product_parrafo").innerHTML = this.product.description;
	  		
		  	$(window).scrollTop(0);
		  	this.validateExists();
		  	this.form.price = parseFloat(this.product.value_sale);
		  	this.form.priceaux = parseFloat(this.product.value_sale);
			$('#cart-2').addClass('shake').attr('data-totalitems', this.getListStorage().length);
			let carrito = document.querySelector('.cart-1');
			window.onscroll = function(){
			var top = window.scrollY;
			if (top == 0) {
			  carrito.classList.remove('cart-2');	
			  carrito.classList.add('cart-1');
			}else{
			  carrito.classList.remove('cart-1');
			  carrito.classList.add('cart-2');
			  }
			}
	  }
	}
</script>